import { computed, ref } from 'vue'
import { get } from 'lodash'
import { FindShopHomePageStaffOverview } from '@/api/shopHomePageSummary'
import { useFetch } from '@/use/fetch'
import { useShop } from '@/use/shop'
import dayjs from '@/lib/dayjs'

/**
 * 本月業績較上月同期的變化
 * @param {number} amount 本月業績
 * @param {number} lastAmount 上月同期業績
 * @returns {string | null} 例如 +12.4%；上月同期沒有業績時為 null
 */
export const formatAmountChange = (amount, lastAmount) => {
  if (!lastAmount) return null
  const rate = ((amount - lastAmount) / lastAmount) * 100
  return `${rate >= 0 ? '+' : ''}${rate.toFixed(1)}%`
}

/**
 * 預約開始時間：今日只顯示時間，其他日期加上月日
 * @param {string} start 預約開始時間
 * @param {string} [timezone] 分店時區
 * @param {Date} [now]
 * @returns {string}
 */
export const formatReservationStart = (start, timezone, now = new Date()) => {
  const date = dayjs(start, timezone)
  return date.isSame(dayjs(now, timezone), 'day') ? date.format('HH:mm') : date.format('MM/DD HH:mm')
}

/**
 * 店家首頁服務人員資訊：分店綁定服務人員的今日預約、下一位顧客、本月業績、AI 個人績效優勢
 */
export const useShopHomePageStaffOverview = () => {
  const { simpleFetch } = useFetch()
  const { shopId } = useShop()
  const overview = ref(null)
  const loading = ref(false)

  // 分店沒有綁定服務人員時不顯示服務人員資訊
  const isBound = computed(() => !!get(overview.value, 'appointmentUnit'))

  const getOverview = async () => {
    if (!shopId.value) return
    loading.value = true
    await simpleFetch(FindShopHomePageStaffOverview, { shopId: shopId.value }, (res) => {
      overview.value = res
    })
    loading.value = false
  }

  return { overview, loading, isBound, getOverview }
}
